import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { FilterData } from 'src/components/AutomationTrading/AutomationItem/AutomationItem.style';
import { observable, makeAutoObservable } from 'mobx';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import styled from '@emotion/styled';

export const EditableElements = styled('div', { label: 'EditableElements' })`
    display: flex;
`;

class EditableDataState {
    public inputState: FormInputState<string, unknown>;
    @observable public activeInput: boolean = false;

    public constructor(private readonly props: EditableDataPropsType) {
        const stateValue = props.initValueOrState;
        this.inputState = stateValue instanceof FormInputState ? stateValue : FormInputState.new(stateValue);
        makeAutoObservable(this);
    }

    public onDisable = (): void => {
        this.activeInput = false;
    };

    public onActiveInput = (): void => {
        this.activeInput = true;
    };

    public onSave = (): void => {
        this.activeInput = false;
        this.props.onSave(this.inputState.value);
    };
}

type EditableDataPropsType = {
    initValueOrState: string | FormInputState<string, unknown>;
    onSave: (value: string) => void;
};

export const EditableData = observer('EditableData', (props: EditableDataPropsType) => {
    const [state] = useState(() => new EditableDataState(props));

    if (state.activeInput === false) {
        return <FilterData onClick={state.onActiveInput}>{state.inputState.value}</FilterData>;
    }

    return (
        <EditableElements>
            <Input formInputState={state.inputState} />
            <Button
                size='regular'
                onClick={state.onSave}
            >
                Save
            </Button>
        </EditableElements>
    );
});
